// extracted by mini-css-extract-plugin
export default {"checkbox":"JKK4MM"};